import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import {
  ConversationType,
} from '../AIPrompt/utils';

import {
  formatTimestamp,
  workoutMessageFormat,
} from './utils';
import {
  MessageContainer,
  Message,
  MessageContent,
  Timestamp,
  ScrollableContainer,
} from './styles';

const ConversationHistory = ({ conversationHistory }) => {
  const scrollRef = useRef(null);

  // Scroll to the bottom of the conversation history when it changes
  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({ top: scrollRef.current.scrollHeight, behavior: 'smooth' });
    }
  }, [conversationHistory]);

  return (
    <ScrollableContainer ref={scrollRef}>
      {conversationHistory.map((message) => (
        <MessageContainer
          key={`${message.type}-${message.timestamp}`}
          $isUser={message.type === ConversationType.USER}
        >
          <Message $isUser={message.type === ConversationType.USER}>
            <MessageContent>
              {message.message}
              {!!message.workout && `\n\n${workoutMessageFormat(message.workout)}`}
            </MessageContent>
            <Timestamp>{formatTimestamp(message.timestamp)}</Timestamp>
          </Message>
        </MessageContainer>
      ))}
    </ScrollableContainer>
  );
};

ConversationHistory.propTypes = {
  conversationHistory: PropTypes.array.isRequired,
};

export default ConversationHistory;
